import React, { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { getAppUrl } from 'utils/defines';
import { useSalesNetwork } from 'utils/hooks/useSalesNetworks';
import useTranslation from 'utils/hooks/useTranslation';
import { getBreadcrumbItems } from 'configApp';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { scrollToWindowTop } from 'utils/helpers';
import { useProject } from 'utils/hooks/useProject';
import * as ProjectStore from "store/projectSlice";


interface BreadcrumbProps {
  handleSubmit?: any,
  title?: string
}

const Breadcrumb: React.FC<BreadcrumbProps> = () => {
  const { network, isThermor } = useSalesNetwork();
  const projectStore = useAppSelector((state) => state.project);
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  //const [active, setActive] = useState<number>()
  //const { step } = useParams();
  const navigate = useNavigate();
  const { changeStep } = useProject();
  const active = projectStore.project.currentStep;


  useEffect(() => {

    // if (step) {
    //   const item = getBreadcrumbItems(network?._parameters.disabledSteps).find((i) => i.id === step);
    //   if (item) {
    //     setActive(item.index);
    //   }
    // }
    checkStep()

  }, [])

  /**
   * Update breadcrumb (use above)
   * @param location
   * @param action
   */
  const checkStep = useCallback(() => {
    const pathname = location.pathname.split('/'); //NOSONAR
    // Search for the breadcrumb step in location path
    // Then update breadcrumb step if match with a BREADCRUMB_ITEM
    for (let i = pathname.length - 1; i > 0; i--) {
      const endPath = pathname[i];
      const found = getBreadcrumbItems(network?._parameters.disabledSteps).findIndex((item: any) => item.id === endPath);
      if (found >= 0) {
        changeStep(found);
        continue; //NOSONAR
      }
    }
  }, [changeStep, network?._parameters.disabledSteps])

  const navigateToItem = useCallback((item: any) => {
    if (projectStore.project.maxReachedStep >= item.index) {
      //scrollToWindowTop();
      dispatch(ProjectStore.setSelectedCompareProducts([]));
      dispatch(ProjectStore.setSelectedCompareProductIds([]));
      navigate(getAppUrl(`/project/${item.id}` + (item.params ? `/${item.params}` : '')))
    }
  }, [navigate, projectStore.project.maxReachedStep])

  const thermorContex = <>
    {
      getBreadcrumbItems(network?._parameters.disabledSteps).map((item: any) => {
        const isSelected = active === item.index;
        const isChecked = active >= item.index;
        return (
          <>
            {item.index > 0 && <separator data-horizontal=""
              {...(isChecked ? { "className": "fill" } : {})}>
            </separator>
            }
            <label
              radio=""
              data-custom=""
              {...(isChecked ? { "className": "fill" } : {})}
              //className="fill"
              //onChange={() => setActive(item.index)}
              onClick={() => navigateToItem(item)}
            >
              <input
                type="radio"
                name="breadcrumb"
                id="breadcrumb"
                //checked
                {...(isSelected ? { checked: true } : {})}
                aria-hidden="true"
                disabled={projectStore.project.maxReachedStep < item.index}
                value={item.index}
              />
              <box>
                <check></check>
                <ink></ink>
              </box>
              <text>{t(item.label)}</text>
              <separator data-horizontal=""></separator>
            </label>
          </>
        )
      })
    }
  </>;

  const atlanticContex = <>
    {getBreadcrumbItems(network?._parameters.disabledSteps).map((item: any, index: number) => {
      const isSelected = active === item.index;
      const isChecked = active > item.index;
      return (
        <React.Fragment key={index}>
          {item.index > 0 && <icon data-opacity="10">arrow_forward_ios</icon>}
          <group
            data-width="auto"
            data-gap="10"
            data-cursor="pointer"
            data-space="5"
            data-name="breadcrumb_item"
            data-wrap="no"
            data-align="center"
            // onClick={() => setActive(item.index)}
            {...(projectStore.project.maxReachedStep < item.index ? { "data-disabled": "" } : {})}
            onClick={() => navigateToItem(item)}
          >
            {!isChecked && <group
              //data-adaptive="desktop"
              data-space="1"
              data-length="30"
              data-height="30"
              data-align="center"
              data-justify="center"
              data-radius="30"
              data-background={isSelected ? "main" : "main-lighter"}
              {...(isSelected ? { "data-color": "white" } : { "data-color": "main" })}
            >{item.index + 1}</group>}

            {isChecked && <group
              //data-adaptive="mobile"
              data-space="1"
              data-length="30"
              data-height="30"
              data-align="center"
              data-justify="center"
              data-radius="30"
              data-background={isSelected ? "main" : "main-lighter"}
            >
              <icon data-icon-size="small" data-color="main">check</icon>
            </group>}

            <text
              data-adaptive="desktop"
              data-color=""
              //data-weight="300"
              data-weight={isSelected ? "400" : "300"}
              //data-text-size="14"
              data-ellipsis=""
            >{t(item.label)}</text>
            {isSelected && <text data-color="" data-adaptive="mobile" data-weight="400" data-text-size="14" data-wrap="wrap">{t(item.label)}</text>}
          </group>
        </React.Fragment>
      )
    })}
  </>

  return (
    <>
      {
        isThermor ? <>
          <group
            data-justify="center"
            data-align="center"
            data-gap="5"
            data-elevation="7"
            //data-border-bottom=''
            data-index="3"
            data-wrap="no"
            data-sticky="top"
            data-sticky-level="60"
            data-background='white'
          >
            <group data-wrap="no" data-space="10" data-space-vertical="15" data-align="center" data-max-length="1440" data-name="breadcrumb thermor">
              {thermorContex}
            </group>
          </group>
        </>
          :
          <>
            <group
              data-justify="center"
              data-align="center"
              data-gap="5"
              data-elevation="6"
              data-index="103"
              data-background='white'
              data-wrap="no"
              data-sticky="top"
              data-sticky-level="90"
              data-test="1"
              data-adaptive='desktop'
            >
              <group data-wrap="no" data-space="10" data-space-vertical="15" data-gap="20" data-align="center" data-max-length='1440' data-name="breadcrumb" data-justify='center' data-text-size="large">
                {atlanticContex}
              </group>
            </group>

            <group
              data-justify="center"
              data-align="center"
              data-gap="5"
              data-elevation="6"
              data-index="3"
              data-background='white'
              data-wrap="no"
              data-sticky="top"
              data-sticky-level="75"
              data-test="2"
              data-adaptive='mobile'
            >
              <group data-wrap="no" data-space="10" data-space-vertical="15" data-align="center" data-max-length='1440' data-name="breadcrumb" data-text-size="large">
                {atlanticContex}
              </group>
            </group>
          </>

      }

      {/* { !title && currentStep && <BreadcrumbMobile currentStep={currentStep} handleSubmit={handleSubmit} /> } */}
    </>
  );
}

export default Breadcrumb;
